var IdentificationType;
(function (IdentificationType) {
    IdentificationType["IFRAME"] = "IFRAME";
    IdentificationType["PREID"] = "PRE-ID";
    IdentificationType["AJAX"] = "AJAX";
})(IdentificationType || (IdentificationType = {}));
export default IdentificationType;
